import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";

// import lusukuLogo517 from "../../assets/img/lusukuLogo517.png";
import lusukuLogo517 from "../../assets/img/lusuku_logo_main.png";

const LusukuLogo = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="fixed" color="inherit">
        <Toolbar>
          <Link to="/">
            <Image
              width="80"
              height="85"
              className="d-inline-block align-top pb-2 mt-2"
              src={lusukuLogo517}
              alt="logo"
            />
          </Link>
        </Toolbar>
      </AppBar>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  /* The AppBar inside is position:fixed (out of flow), so this wrapper has no
     real content height. It must NOT flex-grow — as the first child of the
     page's flex-column container, flexGrow:1 made this empty div expand and
     shove the form card far down the viewport. */
  root: {
    flexGrow: 0,
  },
}));
export default LusukuLogo;
